var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandicapAccessible = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.14,
  cy: 5,
  r: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.74 10.55 2.83 2.83 4.06-4.06a1.25 1.25 0 0 0 0-1.77l-3.18-3.18a1.25 1.25 0 0 0-1.77 0L8.39 6.66a.5.5 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.51.51 0 0 1 .71 0 .5.5 0 0 1 0 .71Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 12H13l2.68-2.68a1.25 1.25 0 0 0 0-1.77l-3.23-3.18a1.25 1.25 0 0 0-1.77 0l-3 3a.5.5 0 0 0 0 .71l.71.71a.5.5 0 0 0 .7 0l2.12-2.13a.51.51 0 0 1 .71 0 .5.5 0 0 1 0 .71l-2.68 2.69A4.52 4.52 0 0 0 8.5 10a5.5 5.5 0 1 0 5.5 5.5 5.72 5.72 0 0 0-.21-1.5H16v4.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5.25A1.25 1.25 0 0 0 16.75 12ZM8.5 19a3.5 3.5 0 1 1 3.5-3.5A3.5 3.5 0 0 1 8.5 19Z"
})));
export default SvgHandicapAccessible;